var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.57999 8.69925C6.59349 8.71125 6.60624 8.7225 6.61899 8.736C7.42824 9.5655 7.8745 10.6642 7.8745 11.8305V14.8185L9.5515 13.905C9.6835 13.833 9.76525 13.692 9.76525 13.5367V11.8215C9.76525 10.6597 10.207 9.56475 11.0087 8.73975L14.6365 4.881C14.8712 4.63125 15.0002 4.3035 15.0002 3.95775V3.25575C15.0002 2.90775 14.7257 2.625 14.3897 2.625H3.23649C2.89974 2.625 2.62524 2.90775 2.62524 3.25575V3.95775C2.62524 4.3035 2.75424 4.63125 2.98899 4.88025L6.57999 8.69925ZM7.60975 16.1257C7.45825 16.1257 7.30824 16.0852 7.17174 16.0042C6.90774 15.8467 6.74949 15.5685 6.74949 15.2595V11.8305C6.74949 10.9792 6.43224 10.1775 5.85399 9.56325C5.83674 9.549 5.81949 9.53325 5.80449 9.51675L2.16999 5.652C1.73799 5.193 1.50024 4.59075 1.50024 3.95775V3.25575C1.50024 2.2875 2.27949 1.5 3.23649 1.5H14.3897C15.346 1.5 16.1252 2.2875 16.1252 3.25575V3.95775C16.1252 4.59 15.8875 5.1915 15.457 5.65125L11.8217 9.51675C11.2195 10.1377 10.8902 10.9545 10.8902 11.8215V13.5367C10.8902 14.1037 10.5835 14.6227 10.09 14.8927L8.01925 16.0207C7.89024 16.0905 7.75 16.1257 7.60975 16.1257Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter2);
export default __webpack_public_path__ + "static/media/Filter-2.57eb0cd6d35b4c01812374f2d248186b.svg";
export { ForwardRef as ReactComponent };